import * as React from 'react';
import { BalloonImage as BalloonImageComponent } from '../../components/BalloonImage';
import * as styles from './BalloonImage.css';

interface IBalloonImageProps {
  imageUrl?: string | null;
  newBuildingName?: string | null;
}

export function BalloonImage({ imageUrl, newBuildingName }: IBalloonImageProps) {
  if (!imageUrl) {
    return null;
  }

  return (
    <div className={styles['image-wrapper']}>
      <BalloonImageComponent imageUrl={imageUrl} title={newBuildingName || ''} />
    </div>
  );
}
